const styles = {
  root: {
    paddingBottom: 40,
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      '& thead tr': {
        // borderBottom: '1px solid #DADADA',
        '& td:first-child': {
          borderRadius: '10px 0 0 0',
        },
        '& td:last-child': {
          borderRadius: '0 10px 0 0',
        },
      },
      '& tbody tr': {
        border: '1px solid #E5E5E5',
      },
      '& tbody tr:nth-child(even)': {
        background: '#FDFDFD',
      },
      '& td': {
        padding: 16,
      },
      '& tbody td:last-child': {
        textAlign: 'right',
      },
    },
  },
};

export default styles;
